// Merchant pricing extension (admin side): the Pricing tab of a merchant's
// product dialog. A merchant sells a product once, at one price — an amount
// and its currency — so the framework's Pricing tab (purchase type, the
// StorePrice editor with its platforms, phases and currencies) is replaced by
// this one wherever the dialog is a merchant's. A platform admin keeps the
// framework's tab: the extension is not visible to them, and a replacement
// only takes a tab over while it is visible.
//
// The price is the catalog editor's `cost`, saved into the product's
// StorePrice by the catalog save; the type is made a one-time purchase on
// Save (./pricing-state.jsx). The server half only declares the id.
import { CurrencyDollarIcon } from "@heroicons/react/24/outline"
import VendorPricingTab from "./VendorPricingTab"
import { VendorPricingProvider } from "./pricing-state"
import { CatalogEditorProvider, useCatalogVisibilityContext } from "../shared/catalog-editor"
import { useVendorVisibilityContext } from "../shared/vendor-visibility"
import { reviewBadge } from "../shared/review-marks"

export const StoreProductExtension = {
  // stands where the built-in Pricing tab stood (the editor places a
  // replacement in the slot of the tab it replaces)
  replaces: ["pricing"],
  // every product has a price: the content type's list of extensions does not scope this tab
  allProducts: true,
  id: "vendor-pricing",
  label: "Pricing",
  description: "A merchant's price: one amount in one currency, sold as a one-time purchase (admins keep the full Pricing tab)",
  section: {
    component: VendorPricingTab,
    label: "Pricing",
    icon: CurrencyDollarIcon,
    // what a reviewer marked here for the vendor (shared/review-marks)
    badge: reviewBadge("vendor-pricing"),
    order: 110,
    // a merchant's catalog product; an admin and a product of another store category keep the framework's tab
    visible: (context) => !!context?.vendorEditor && !!context?.catalogProduct,
  },
  // the catalog editor holds the price; the merchant's state sits inside it
  provider: [CatalogEditorProvider, VendorPricingProvider],
  visibilityContext: [useCatalogVisibilityContext, useVendorVisibilityContext],
}
